import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

import { apiSlice } from '@api/apiSlice';
import { bonusServiceApiSlice } from '@api/bonusServiceApiSlice';
import {
  playerReportingBonusApiSlice,
  playerReportingBonusServiceApiSlice,
} from '@api/createPlayerReportingApi';
import { playerReportingServiceApiSlice } from '@api/playerReportingServiceApiSlice';
import rootReducer from '@store/rootReducer';

import { ENV } from '@constants';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  stateTransformer(state: RootState): unknown {
    return {
      ...state,
      api: null,
      menu: null,
      sportsData: null,
      ruleEngine: null,
      casinoGames: null,
      bonusService: null,
      reportingService: null,
      playerReportingService: null,
      playerReportingBonusApi: null,
    };
  },
});

const middlewareList = [
  apiSlice.middleware,
  bonusServiceApiSlice.middleware,
  playerReportingServiceApiSlice.middleware,
  playerReportingBonusApiSlice.middleware,
  playerReportingBonusServiceApiSlice.middleware,
];

export const store = configureStore({
  reducer: rootReducer,
  devTools: ENV.MODE === 'development',
  enhancers: (getDefaultEnhancers) =>
    [...getDefaultEnhancers(), sentryReduxEnhancer] as ReturnType<
      typeof getDefaultEnhancers
    >,
  middleware: (getDefaultMiddleware) =>
    [...getDefaultMiddleware(), ...middlewareList] as ReturnType<
      typeof getDefaultMiddleware
    >,
});

type RootState = ReturnType<typeof rootReducer>;
type AppDispatch = typeof store.dispatch;

export type { RootState, AppDispatch };
